const attachment = {
  id: '544f947c-390b-4200-b599-d60b3a5bd46e',
  contentType: 'application/vnd.microsoft.card.adaptive',
  name: null,
  thumbnailUrl: null,
  contentUrl: null,
  content: JSON.stringify({
    type: 'AdaptiveCard',
    $schema: 'http://adaptivecards.io/schemas/adaptive-card.json',
    version: '1.4',
    body: [
      {
        type: 'ColumnSet',
        columns: [
          {
            type: 'Column',
            width: 1,
            items: [
              {
                type: 'TextBlock',
                text: '{{JOB_TITLE}}',
                wrap: true,
                fontType: 'Default',
                size: 'Large',
                weight: 'Bolder'
              }
            ]
          }
        ]
      }
    ],
    actions: [
      {
        type: 'Action.OpenUrl',
        url: '{{JOB_SHARE_LINK}}',
        title: 'Apply Now'
      },
      {
        type: 'Action.OpenUrl',
        url: '{{JOB_COPY_SHARE_LINK}}',
        title: 'Copy Link'
      },
    ]
  })
};

export default {
  id: 'teams_promote_an_internal_job',
  title: 'Promote an internal job',
  type: 'Direct / Channel',
  canSendToChannel: true,
  relations: [ 'JOB' ],
  description: 'Message a selected job to your employees so they can apply or share it with their colleagues.',
  body: {
    attachments: [ attachment ],
    body: {
      contentType: 'html',
      content: `
      <div>
        <p>[[INPUT_INTRODUCTION_TEXT]]</p>
        <attachment id='${attachment.id}'></attachment>
      </div>`.split('\n').map(line => line.trim().replaceAll('\n', '')).join(''),
    },
  },
  inputs: {
    INPUT_INTRODUCTION_TEXT: {
      label: 'Intro',
      placeholder: 'Apply to the following job or share that with your collegues to win some rewards! ...',
      defaultValue: 'Apply to the following job or share that with your collegues to win some rewards!',
      type: 'HTML'
    }
  }
};


// WEBPACK FOOTER //
// ./src/views/campaign-admin/templates/teams/promoteInternalJob.js